import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";

import OrganizationProvider from "@/components/providers/OrganizationProvider";
import ProjectProvider from "@/components/providers/ProjectProvider";
import SurveyProvider from "@/components/providers/SurveyProvider";
import AboutUs from '@/pages/AboutUs';
import AccountSetupPage from '@/pages/AccountSetupPage';
import { ErrorBoundaryPage } from "@/pages/ErrorBoundaryPage";
import ForgotPassword from '@/pages/ForgotPassword';
import HomePage from '@/pages/HomePage';
import ImportQuestions from '@/pages/ImportQuestions';
import Login from '@/pages/Login';
import { ManageOrganizationMembers } from "@/pages/ManageOrganization/ManageMembers";
import { ManageOrganization } from "@/pages/ManageOrganization/ManageOrganization";
import { QuestionBank } from "@/pages/ManageOrganization/QuestionBank";
import { SurveyTemplate } from "@/pages/ManageOrganization/SurveyTemplate";
import { AddSurveyToProject } from "@/pages/ManageProject/AddSurveyToProject";
import { EditProject } from "@/pages/ManageProject/EditProject";
import { ManageProject } from "@/pages/ManageProject/ManageProject";
import { ProjectMembers } from "@/pages/ManageProject/ProjectMembers";
import { ManageProjects } from "@/pages/ManageProjects/ManageProjects";
import { EditSurvey } from "@/pages/ManageSurvey/EditSurvey";
import { ExportSurvey } from '@/pages/ManageSurvey/ExportSurvey';
import { ManageSurvey } from "@/pages/ManageSurvey/ManageSurvey";
import { Questions } from "@/pages/ManageSurvey/SurveyQuestionsPage";
import { ManageSurveyTemplates } from "@/pages/ManageSurveyTemplates";
import NotFoundPage from "@/pages/NotFoundPage";
import OrganizationHomePage from "@/pages/OrganizationHomePage";
import Register from '@/pages/Register';
import Settings from "@/pages/Settings";
import UpdatePassword from '@/pages/UpdatePassword';
import * as Sentry from '@sentry/react';
import Logout from "./Logout";
import Root from "./Root";
import RedirectAuth from "./redirects/RedirectAuth";
import { RedirectManageOrganizationWithLayout } from "./redirects/RedirectManageOrganizationWithLayout";
import { RedirectProjectWithLayout } from "./redirects/RedirectProjectWithLayout";
import RedirectToManageSurveyWithLayout from "./redirects/RedirectToManageSurveyWithLayout";

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)
export const router = sentryCreateBrowserRouter(createRoutesFromElements(
    <Route path='/' element={<Root />} errorElement={<ErrorBoundaryPage />}>
        <Route path='about' element={<AboutUs />} />
        <Route path='' element={<RedirectAuth to="/welcome" />} >
            <Route path='login' element={<Login />} />
            <Route path='forgot-password' element={<ForgotPassword />} />
            <Route path='register' element={<Register />} />
        </Route>
        <Route path='' element={<RedirectAuth to="/login" requiresAuth />} >
            <Route path="logout" element={<Logout />} />
            <Route path='account-setup' element={<AccountSetupPage />} />
            <Route path='settings' element={<Settings />} />
            <Route path='welcome' element={<HomePage />} />
            <Route path='update-password' element={<UpdatePassword />} />
            <Route
                path='organization'
            >
                <Route path=':orgId' element={<OrganizationProvider />} >
                    <Route index element={<OrganizationHomePage />} />
                    <Route path="manage-organization" element={<RedirectManageOrganizationWithLayout />} >
                        <Route index element={<ManageOrganization />} />
                        <Route path="organization-members" element={<ManageOrganizationMembers />} />
                        <Route path="projects" element={<ManageProjects />} />
                        <Route path="questions-bank" element={<QuestionBank />} />
                        <Route path="survey-bank" element={<ManageSurveyTemplates />} />
                        <Route path="survey-bank/add-template" element={<SurveyTemplate />} />
                        <Route path="survey-bank/edit-template/:surveyId" element={<SurveyTemplate />} />
                        {/* <Route path="survey-bank-old" element={<SurveyBank />} /> */}
                        {/* <Route path="project/:projectId/surveys" element={<ManageSurveyTemplates />} /> */}
                    </Route>
                    <Route
                        path='project/:projectId'
                        element={<ProjectProvider />}
                    >  
                        <Route path='manage-project' element={<RedirectProjectWithLayout />}>
                            <Route index element={<ManageProject />} />
                            <Route path='edit' element={<EditProject />} />
                            <Route path='members' element={<ProjectMembers />} />
                            <Route path='add-survey' element={<AddSurveyToProject />} />
                        </Route>

                        <Route path='survey/:surveyId' element={<SurveyProvider />} >
                            <Route path='manage-survey' element={<RedirectToManageSurveyWithLayout />}>
                                <Route index element={<ManageSurvey />} />
                                <Route path='edit' element={<EditSurvey />} />
                                <Route path='export' element={<ExportSurvey />} />
                                <Route path='questions' element={<Questions />} />
                            </Route>
                        </Route>
                    </Route>
                    <Route path='import-questions' element={<ImportQuestions />} />
                </Route>
            </Route>
        </Route>
        <Route path='*' element={<NotFoundPage />} />
    </Route>
))


